const digits = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/[^\d]/g, "");

export const WHATSAPP_NUMBER = digits;
export const BUSINESS_EMAIL = process.env.REACT_APP_BUSINESS_EMAIL || "sales@haqilaglobal.com";
export const WHATSAPP_MESSAGE =
  "Hello HAQILA, I'm interested in your Indonesian commodity products. I'd like to discuss my sourcing requirements.";

export const waLink = (message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;

export const CATALOG_WA_MESSAGE = "Hello HAQILA, I'd like to request your product catalog.";

export const PRODUCT_DOCUMENTS = [
  {
    label: "Download Product Catalogue (PDF)",
    filename: "HAQILA_Coconut_Shell_Charcoal_Briquettes_Catalogue.pdf",
    testId: "product-catalog-download",
  },
  {
    label: "Download Product Specification (PDF)",
    filename: "HAQILA_Product_Specification_Sheet.pdf",
    testId: "product-specification-download",
  },
];

export const PARTNER_CAPACITY = "Selected Partner Facility — Banten. Production capacity: up to 26 MT/day, subject to production schedule and confirmed order requirements.";

export const SPECIFICATION_QUALIFICATION = "Final specifications are confirmed according to the applicable production batch and COA.";

export const SHAPE_QUALIFICATION = "Additional sizes and shapes may be available according to buyer requirements, manufacturing capability and confirmed production specification.";

export const REGISTERED_COMPANY = [
  { label: "Legal Entity", value: "PT HAQILA GLOBAL TRADING" },
  { label: "Business Registration (NIB)", value: "1808260081522" },
  { label: "Location", value: "Tangerang, Banten, Indonesia" },
  { label: "Email", value: BUSINESS_EMAIL },
];

export const SOCIAL_LINKS = [
  { label: "Instagram", href: "https://instagram.com/haqila.charcoal", icon: "Instagram" },
  { label: "TikTok", href: "https://www.tiktok.com/@haqila.charcoal", icon: "TikTok" },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/search/results/companies/?keywords=Haqila%20Global%20Trading",
    icon: "Linkedin",
  },
];

// Photography slots — replace each URL with authentic HAQILA / manufacturing-partner
// photography when available. Categories:
//   company_sourcing   : team, manufacturer visits, sourcing at origin
//   raw_material       : coconut shell, carbonized shell, preparation
//   production         : briquette pressing, drying, sorting, quality checking (label "Partner Facility")
//   product            : finished briquettes, close-ups, shapes, dimensions
//   packaging          : cartons, retail boxes, bulk packaging, palletized shipment
//   export             : warehouse, container loading, sealed container, Indonesian port
export const IMAGES = {
  charcoalHero:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/7d9d778a48cef9690f126f416fa9fc0f1231aaf3b8b25f49c09103f4b820645e.jpeg",
  charcoalClose:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/7b0746ff5af032abce9b7f334c070b2c2f988df8404d0a2c23ead188587d6752.jpeg",
  charcoalDetail:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/e07527205d1aeeb9cc511351521338270a1ff2f0d89a5cdb2c259efaf8e0be9e.jpeg",
  logistics:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/a5d0dd4c7e9f9923b3f4e60a5cbd5d3fb57679fe35021cd8a5419fd4147554ea.jpeg",
  containers:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/dc67681c7540d03248e16bca81fc129c7ece5f3bbfe1015a97d24e9ad111545c.jpeg",
  coconutShell:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/e72ae6c6db12c265754c28ac4aea02c1e4a8566580df5e4d141e082b662a800e.jpeg",
  coconutShellAlt:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/70cbcc587941beeeccd791830e55a32f4a865c977de61f73cbb698d93cacee27.jpeg",
  // Studio-style AI-generated placeholder reference images per SKU — swap for real
  // HAQILA product photography once available. Keep same aspect/usage in ProductPage.
  variantShishaCube:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/nmzz355t_hf_20260821_093658_66c3c1e5-879d-4921-8985-1673ea60c986.png",
  variantShishaCubeHole:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/vblr4jge_hf_20260821_100051_cc333ac0-5b62-471d-8453-f1e6aa4d74cd.png",
  variantShishaHexFlower:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/784et7wj_hf_20260821_100051_c3ac662b-e8c4-4eb6-813a-d47fbd0e5ca0.png",
  variantBbqCubeRidged:
    "https://static.prod-images.emergentagent.com/jobs/a9c10482-a696-4918-9f3d-5047b983bb2d/images/f5d42ade0782e3007651df6ac30fd186d9ee2c43bee3e2aa41c60f6478d97d0c.jpeg",
  variantBbqHexFlower:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/dkryd0j6_Gemini_Generated_Image_iusva6iusva6iusv.webp",
  ownerWarehouse:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/pzzbfqpd_IMG_6650.jpeg",
  carsurinLogo:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/h2mb53w4_IMG_7086.png",
  ministryOfTradeLogo:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/v37lw7jh_EA0E8EC0-AA10-4AAC-A3EC-67A10E994C15.webp",
  msdsLogo:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/aohrqzxk_2122903D-F1A1-44BB-9B4E-14BCD23DD93C.png",
  // Manufacturing partner facility photos — "Inside the Supply" gallery on the Sourcing page.
  // Always caption with "partner" / "manufacturing partner" / "at the source" — never "our factory".
  partnerSortingRaw:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/p7zdb43a_Img%201.JPG",
  partnerPacking:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/4q1xmfqt_Img%202.JPG",
  partnerWarehouseSacks:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/ynmdl31v_Img%203.JPG",
  partnerJumboBag:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/mkxldjhq_Img%204.JPG",
  partnerCrusherLine:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/8inhedp6_Img%205.JPG",
  partnerPastePrep:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/e5d8dc5x_Img%206.JPG",
  partnerFormingLine:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/s1z2hok3_Img%207.jpg",
  partnerSkilledWorkforce:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/vt7p85vl_Img%208.JPG",
  partnerCubePacked:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/knlokdz3_Img%209.JPG",
  galleryOwnerWarehouse:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/bhf53jqg_IMG_6625.jpeg",
  galleryGlowingCubes:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/4qtv84aa_IMG_6633.webp",
  galleryBurnTest:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/ky5z41e4_IMG_6639.jpeg",
  galleryBbqLitRaw:
    "https://customer-assets-v7afamib.emergentagent.net/job_e7859763-7706-490d-8538-ac5bbbfd91cf/artifacts/erogdb6e_IMG_6641.jpeg",
  // Brand logo — used in Header/Footer only
  logo:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/2jdsot8z_F8E42191-00F6-45E7-8D80-F5548B7CEA88.webp",
  logoIcon:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/t7ih8gge_IMG_6530.png",
  logoWordmark:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/o3ljh0wz_IMG_6531.png",
  // Real packaging photos — used in product gallery sections only
  packagingBox:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/p5eg13ny_IMG_6517.jpeg",
  packagingBag:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/619z42rh_IMG_6511.webp",
  packagingCarton:
    "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/6ctha7nh_IMG_6510.webp",
};

export const PRODUCTS = [
  {
    slug: "/products/coconut-shell-shisha-charcoal",
    name: "Coconut Shell Shisha Charcoal Briquettes",
    short: "Shisha Charcoal",
    description:
      "Premium coconut shell charcoal briquettes sourced from selected Indonesian manufacturing partners for shisha and hookah applications.",
    image: IMAGES.charcoalClose,
    imageAlt: "Close-up of coconut shell charcoal briquettes for shisha and hookah",
    active: true,
  },
  {
    slug: "/products/bbq-coconut-charcoal",
    name: "BBQ Coconut Charcoal Briquettes",
    short: "BBQ Charcoal",
    description:
      "Coconut shell charcoal briquettes for BBQ, grilling, wholesale and food-service applications.",
    image: IMAGES.charcoalDetail,
    imageAlt: "Glowing coconut shell BBQ charcoal briquettes for grilling",
    active: true,
  },
];

export const COMING_SOON = [
  "Biomass & Sawdust",
  "Indonesian Coffee",
  "Coconut Products",
  "Indonesian Spices",
  "Cocoa",
];

export const NAV_LINKS = [
  { label: "Products", to: "/products" },
  { label: "Our Sourcing", to: "/sourcing" },
  { label: "Why HAQILA", to: "/why-haqila" },
  { label: "Export Process", to: "/export-process" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const RESOURCE_LINKS = [
  { label: "Commercial Terms", to: "/commercial-terms" },
  { label: "Private Label", to: "/private-label" },
  { label: "Documentation", to: "/documentation" },
  { label: "FAQ", to: "/faq" },
];
